var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMachineIconLightBlue = function SvgMachineIconLightBlue(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#3AACC8",
    fillOpacity: 0.4,
    d: "M8 7c3.314 0 6-1.343 6-3s-2.686-3-6-3-6 1.343-6 3 2.686 3 6 3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#3AACC8",
    fillOpacity: 0.4,
    d: "M8 8.5c1.84 0 3.579-.37 4.914-1.037A6.3 6.3 0 0 0 14 6.78V8c0 1.657-2.686 3-6 3S2 9.657 2 8V6.78c.346.273.72.5 1.087.683C4.42 8.131 6.16 8.5 8 8.5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#3AACC8",
    fillOpacity: 0.4,
    d: "M8 12.5c1.84 0 3.579-.37 4.914-1.037.366-.183.74-.41 1.086-.684V12c0 1.657-2.686 3-6 3s-6-1.343-6-3v-1.22c.346.273.72.5 1.087.683C4.42 12.131 6.16 12.5 8 12.5"
  })));
};
export { SvgMachineIconLightBlue as ReactComponent };
export default __webpack_public_path__ + "737a42fce58e6d98e7b0743c23540e3c.svg";